<script lang="ts">
    import { _ } from 'svelte-i18n';
    import { get } from 'svelte/store';

    import TemplateHeaderDuo from '../../shared/TemplateHeaderDuo.svelte';
    import TemplateStandard from '../../shared/TemplateStandard.svelte';
    import { onMount } from 'svelte';
    import { ColumnSettingsApi, type ImportAnalyzeResponseType } from '../ColumnSelectPro/ColumnSettingsApi';
    import { api } from '../../../stores/api';
    import { currentImport } from '../../shared/ColumnSelectPro/currentImport';
    import ImportAnalyze from './ImportAnalyze/ImportAnalyze.svelte';
    import { mainMenu } from '../../../stores/store';
    import { Navigation } from '../../utilities/Navigation';
    import { openModal } from 'svelte-modals';
    import ModalError from '../../shared/Modals/ModalError.svelte';
    import ButtonMain from '../../shared/ButtonMain.svelte';
    import ErrorInline from '../../shared/ErrorInline.svelte';
    import ButtonSecondary from '../../shared/ButtonSecondary.svelte';
    import IconBack from '../../shared/Icons/IconBack.svelte';
    import TemplateRow from '../../shared/TemplateRow.svelte';
    import { NotificationSystem } from '../NotificationSystem/NotificationSystem';
    import IconPending from '../../shared/Icons/IconPending.svelte';
    import { Umami } from '../../utilities/Umami';
    import { app } from '../../../stores/app';

    let analyze: ImportAnalyzeResponseType | null = null;
    let error: string = '';
    let processing: boolean = false;
    let startedImporting: boolean = false;

    let agreeToImportWithoutInvalidRows: boolean = false;

    onMount(() => {
        reloadAnalyze();
    });

    function confirm() {
        startedImporting = true;
        ColumnSettingsApi.confirm($api, $currentImport.id)
            .then(() => {
                if ($currentImport?.file_type === 'connections') {
                    $NotificationSystem.changeIntervalSeconds(2);
                }
                Umami.event('import_confirm', { import_id: $currentImport.id });
                let link = $mainMenu.items.find(item => item.id === 'PageGeocoding')?.to || '/';
                console.info('AssignColumns: link', link);
                Navigation.navigate(link);
                processing = false;
            })
            .catch(err => {
                console.warn('AssignColumns: data', $currentImport);
                console.warn('AssignColumns: Columns settings confirm error!', err);
                Umami.error('import_confirm', err, { import_id: $currentImport?.id ?? null });
                openModal(ModalError, {
                    header: 'Error',
                    message: 'An error occurred during import.',
                    error: String(err),
                });
                processing = false;
            })
            .finally(() => {
                startedImporting = false;
            });
    }

    function isConfirmEnabled(agreeToImportWithoutInvalidRows: boolean): boolean {
        return (
            !processing &&
            analyze !== null &&
            (analyze.invalid.count === 0 || agreeToImportWithoutInvalidRows) &&
            analyze.count_items_after_import > 0
        );
    }

    function isLimitExceeded(): boolean {
        return !$app.settingsReadonly?.allow_limit_exceeding && analyze !== null && analyze.max_items < analyze.count_items_after_import;
    }

    function reloadAnalyze() {
        analyze = null;
        console.log('PageImportAnalyze mounted');
        if ($currentImport && $currentImport.id !== null) {
            ColumnSettingsApi.analyze($api, $currentImport.id)
                .then(response => {
                    analyze = response;
                })
                .catch(err => {
                    console.error(err);
                    error = $_('Import analysis error');
                });
        } else {
            error = $_('No import selected');
        }
    }
</script>

<TemplateStandard>
    <div slot="submenu"></div>
    <div slot="header" style="width: 100%;">
        <TemplateHeaderDuo>
            <div slot="main-header">
                <TemplateRow>
                    <IconBack
                        on:click={() => {
                            if (startedImporting) {
                                console.warn('Import is in progress, cannot go back');
                                return;
                            }
                            window.history.back();
                        }}
                        scale={0.7}
                    />
                    {$_('Summary before import')}
                </TemplateRow>
            </div>
            <div slot="main-buttons">
                <!--                <ButtonMain-->
                <!--                    text={$_('btn-next')}-->
                <!--                    on:click={confirm}-->
                <!--                    disabled={processing || analyze === null}-->
                <!--                />-->
            </div>
        </TemplateHeaderDuo>
    </div>
    <div slot="content">
        <div style="display: flex; align-items: center; justify-content: center; padding: 40px 20px; flex-direction: column;">
            {#if analyze && isLimitExceeded()}
                <div style="margin: 20px 0;">
                    <ErrorInline
                        text={$_('Import limit exceeded message (ext)', { values: {after_import: analyze.count_items_after_import, limit: analyze.max_items }})}
                    />
                </div>
            {/if}
            {#if error !== ''}
                <ErrorInline text={error} />
            {:else if analyze}
                <ImportAnalyze {analyze} bind:agreeToImportWithoutInvalidRows {reloadAnalyze} />
            {:else}
                <div>{$_('Import analysis in progress...')}</div>
            {/if}

            {#if analyze && !isLimitExceeded()}
                <div
                    style="display: flex; justify-content: space-between; width: 100%;
margin: 30px 0;"
                >
                    <ButtonSecondary
                        text={$_('Cancel')}
                        showIcon={false}
                        on:click={() => {
                            Umami.event('import_cancel', { import_id: $currentImport?.id ?? null });
                            Navigation.navigate('/');
                        }}
                        disabled={processing || analyze === null || startedImporting}
                    />
                    {#if startedImporting}
                        <IconPending scale={1} spin={true} />
                    {:else}
                        <ButtonMain
                            requiresWrite={true}
                            text={$_('Import')}
                            on:click={confirm}
                            disabled={!isConfirmEnabled(agreeToImportWithoutInvalidRows) || startedImporting}
                        />
                    {/if}
                </div>
            {/if}
        </div>
    </div>
</TemplateStandard>

<style>
</style>
